<template>
  <v-app toolbar>
    <v-dialog v-model="info" fullscreen @click.native.stop="info = !info">
      <v-card class="infoDialog">
        <div class="menuIns">
          <v-icon dark>menu</v-icon>
        </div>
        <div class="menuInsTip"> <br>
          <strong>Menu button</strong><br>
          <small>Opens left navigation menu where you can skip book chapters</small>
        </div>
        <div class="socMenu">
          <v-icon dark>fa-linkedin</v-icon>
          <v-icon dark>fa-twitter</v-icon>
          <v-icon dark>fa-facebook</v-icon>
          <v-icon dark>fa-tumblr</v-icon>
          <v-icon dark>fa-pinterest</v-icon>
        </div>
        <div class="socMenuMob">
          <v-icon>share</v-icon>
        </div>
        <div class="socMenuTip"> <br>
          <strong>Social share buttons</strong><br>
          <small>Share book on your chousen social network</small>
        </div>
        <div class="resize-settings">
          <v-icon dark>settings</v-icon>
        </div>
        <div class="resize-settings-tip"> <br>
          <strong>Settings button</strong><br>
          <small>Change various visual settings</small>
        </div>
        <div class="info-button">
          <v-icon dark>fa-info-circle</v-icon>
        </div>
        <div class="info-button-tip"> <br>
          <strong>Info button</strong><br>
          <small>Open or close informational screen</small>
        </div>
        <div class="left-button">
          <v-icon dark>chevron_left</v-icon>
        </div>
        <div class="left-button-tip"> <br>
          <strong>Left/previous</strong><br>
          <small>Navigate previous page or chapter in book view(on mobile screen just swipe right)</small>
        </div>
        <div class="right-button">
          <v-icon dark>chevron_right</v-icon>
        </div>
        <div class="right-button-tip"> <br>
          <strong>Right/next</strong><br>
          <small>Navigate next page or chapter in book view(on mobile screen just swipe left)</small>
        </div>
        <div class="buy-buttons">
        <img src="https://www.goodreads.com/book/show/22138137-mastering-the-craft-of-writing">
        </div>
        <div class="buy-buttons-mob">
          <v-icon>shopping_basket</v-icon>
        </div>
        <div class="buy-buttons-tip"> <br>
          <strong>Buy books links</strong><br>
          <small>Visit sellers shop to purchace this book</small>
        </div>
        <div class="headline">Instructions</div>
        <v-btn flat class="closeDialog" @click.native.stop="info = false" :ripple="false">Close</v-btn>
      </v-card>
    </v-dialog>
    <v-navigation-drawer class="menu" temporary  hide-overlay @click.native.stop="drawer = !drawer" clipped v-model="drawer" enable-resize-watcher disable-route-watcher touchless>
      <v-list>
        <v-list-tile v-for="item in items" v-bind:href="item.path" :key="item.name" :to="item.path" exact :ripple="false" width="100%">
          <v-list-tile-action>
            <img height="55px" :src="item.image">
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title active>{{ item.name }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
    <v-navigation-drawer clipped temporary hide-overlay v-model="drawerRight" light right enable-resize-watcher touchless>
      <v-list>
        <settings></settings>
      </v-list>
    </v-navigation-drawer>
    <v-navigation-drawer class="mini-bar" v-model="buyBar" absolute clipped mini-variant light enable-resize-watcher touchless >
      <v-list :ripple="false">
        <a v-for="buy in buys" :href="buy.url" :key="buy.title" target="_blank">
          <img :src="buy.img">
        </a>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar class="main-menu" fixed persistent>
      <v-btn flat class="main-menu-button" @click.native.stop="drawer = !drawer, info = false, buyMenu = false, socialMenu = false, drawerRight = false" :ripple="false"v-tooltip:right="{ html: 'Book menu' }">
        <v-icon>menu</v-icon>
      </v-btn>
      <v-toolbar class="desktop-social-btn">
        <button onclick="window.open('https://www.linkedin.com/shareArticle?mini=true&amp;amp;url=https://localhost%3A3000/books/Xbvl2M/%3F1496225701835&amp;amp;title=A%20Pocket%20Guide%20to%20Combining%20typefaces&amp;amp;summary=Get%20%23Free%20%23Sample%20of%20A%20Pocket%20Guide%20to%20Combining%20typefaces%20-%20%0D%0ABestselling%20author%20and%20erstwhile%20musician%20Harper%20Ellison%20started%20running%20from%20his%20troubled%20past%20before%20he%20graduated%20high%20school.%20When%20his%20sister%20tracks%20him%20down%20ten%20years%20later%2C%20Harper...&amp;amp;source=LinkedIn','_blank')" v-tooltip:bottom="{ html: 'Share on LinkedIn' }">
          <v-icon>fa-linkedin</v-icon>
        </button>
        <button onclick="window.open('https://twitter.com/intent/tweet?text=Get%20%23Free%20%23Sample%20of%20A%20Pocket%20Guide%20to%20Combining%20typefaces%20&amp;amp;url=https://localhost%3A3000/books/Xbvl2M/%3F1496225701835&amp;amp;via=textcafecom','_blank')" v-tooltip:bottom="{ html: 'Share on Twitter' }">
          <v-icon>fa-twitter</v-icon>
        </button>
        <button onclick="window.open('https://www.facebook.com/sharer/sharer.php?u=https://localhost%3A3000/books/Xbvl2M/%3F1496225701835','_blank')" v-tooltip:bottom="{ html: 'Share on Facebook' }">
          <v-icon>fa-facebook</v-icon>
        </button>
        <button onclick="window.open('https://www.tumblr.com/widgets/share/tool?canonicalUrl=https://localhost%3A3000/books/Xbvl2M/%3F1496225701835&amp;posttype=link&amp;caption=Get%20%23Free%20%23Sample%20of%20A%20Pocket%20Guide%20to%20Combining%20typefaces%20-%20%0D%0ABestselling%20author%20and%20erstwhile%20musician%20Harper%20Ellison%20started%20running%20from%20his%20troubled%20past%20before%20he%20graduated%20high%20school.%20When%20his%20sister%20tracks%20him%20down%20ten%20years%20later%2C%20Harper...','_blank')" v-tooltip:bottom="{ html: 'Share on Tumblr' }">
          <v-icon>fa-tumblr</v-icon>
        </button>
      </v-toolbar>
      <v-btn flat class="mobile-buy-btn" @click.native.stop="buyMenu = !buyMenu, info = false, drawer = false, socialMenu = false, drawerRight = false">
        <v-icon>shopping_basket</v-icon>
      </v-btn>
      <v-navigation-drawer class="buy-menu" width="100vw" height="auto" hide-overlay temporary clipped v-model="buyMenu" @click.stop="buyMenu = !buyMenu" disable-route-watcher touchless>
        <v-list>
            <v-list-tile v-for="buy in buys" :key="buy.title" v-bind:href="buy.url">
            <v-list-tile-action>
              <img :src="buy.img">
            </v-list-tile-action>
            <v-list-tile-title v-text="buy.title"></v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-navigation-drawer>
      <v-btn flat class="mobile-social-btn" @click.native.stop="socialMenu = !socialMenu, info = false, buyMenu = false, drawer = false, drawerRight = false">
        <v-icon>share</v-icon>
      </v-btn>
      <v-navigation-drawer class="social-menu" width="100vw" height="auto" hide-overlay temporary clipped v-model="socialMenu" @click.stop="socialMenu = !socialMenu" disable-route-watcher persistent touchless>
      <v-list>
          <v-list-tile v-for="social in socials" :key="social.title" v-bind:href="social.url">
            <v-list-tile-action>
              <img :src="social.img">
            </v-list-tile-action>
            <v-list-tile-title v-text="social.title"></v-list-tile-title>
          </v-list-tile>
        </v-list>
        </v-navigation-drawer>
      <v-spacer></v-spacer>
      <v-btn flat class="info-btn" @click.native.stop="info = !info, drawer = false, buyMenu = false, socialMenu = false, drawerRight = false" v-tooltip:bottom="{ html: 'Instructions' }"  :ripple="false">
        <v-icon>fa-info-circle</v-icon>
      </v-btn>
      <v-btn flat class="settings-button" @click.native.stop="drawerRight = !drawerRight, info = false, buyMenu = false, socialMenu = false, drawer = false" v-tooltip:left="{ html: 'Set application visuals' }"  :ripple="false">
        <v-icon>settings</v-icon>
      </v-btn>
    </v-toolbar>
    <v-container fluid>
      <reader></reader>
    </v-container>
  </v-app>
</template>

<script>
import Reader from "./components/Reader.vue";
import Settings from "./components/Settings.vue";
import eventHub from "./event-hub.js";

export default {
  data() {
    return {
      info: false,
      buyBar: true,
      buyMenu: false,
      socialMenu: false,
      focused: false,
      dialogBuy: false,
      dialogShare: false,
      notifications: false,
      sound: true,
      widgets: false,
      show: false,
      iSize: 50,
      selectBook: "Books",
      home: this.$route.path,
      drawer: false,
      drawerRight: false,
      items: [],
      socials: [
        { title: 'LinkedIn', img: '/img/linkedin-logo.svg', url: 'http://www.linkedin.com/shareArticle?mini=true&url=https%3A%2F%2Ftextcafe.com&title=PWA%20Reader&summary=PWA%20book%20reader&source=https%3A%2F%2Ftextcafe.com' },
        { title: 'Twitter', img: '/img/twitter-logo-silhouette.svg', url: 'https://twitter.com/intent/tweet?source=https%3A%2F%2Ftextcafe.com&text=PWA%20Reader:%20https%3A%2F%2Ftextcafe.com' },
        { title: 'Facebook', img: '/img/facebook-logo.svg', url: 'https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Ftextcafe.com&t=PWA%20Reader' },
        { title: 'Tumblr', img: '/img/tumblr-letter-logo.svg', url: 'http://www.tumblr.com/share?v=3&u=https%3A%2F%2Ftextcafe.com&t=PWA%20Reader&s=' },
      ],
      buys: [
        { title: '', img: 'https://www.google.com/s2/favicons?domain=goodreads.com', url: 'https://www.goodreads.com/book/show/22138137-mastering-the-craft-of-writing' },
      ],
      right: null,
      left: null
    };
  },
  created: function() {
    this.$router.options.routes.forEach(route => {
      this.items.push({
        path: route.path,
        name: route.name,
        component: route.component,
        image: '/books/Xbvl2M/cover.jpg'
      });
    });
  },
  watch: {
    $route(to, from) {
      if (to.path === "/") {
        this.home = this.$route.path;
      } else {
        this.home = null;
      }
    },
    iSize: newValue => {
      eventHub.$emit("iSizeChanged", newValue);
    }
  },
  methods: {
    resetScroll() {
      var page = this.$el.querySelector(".book-page");
      page.scrollLeft = 0;
    },
    onBlur() {
      if (this.show === true) {
        this.show = false;
        this.$emit("blur");
      }
    },
    onFocus() {
      if (this.show === false) {
        this.show = true;
        this.$el.querySelector(".book-page").$emit("focus");
      }
    }
  },
  components: {
    settings: Settings,
    reader: Reader
  }
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css?family=Lato");
@import url("https://fonts.googleapis.com/css?family=Raleway");
</style>

<style lang="stylus">
@import '../../node_modules/vuetify/src/stylus/main';
</style>

<style src="../static/style.sass" lang="sass"></style>







// WEBPACK FOOTER //
// App.vue?388d8dd4